import { IconSvgProps } from '../types';

export const Agile = ({ size }: IconSvgProps) => (
  <svg
    id="icon-software-agile"
    width={size}
    height={size}
    viewBox="0 0 64 42"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor" fillRule="nonzero">
        <g>
          <path d="M31.52,34.699 C22.05,34.699 14.37,27.02 14.37,17.5474 C14.37,8.0748 22.05,0.3956 31.52,0.3956 C40.99,0.3956 48.67,8.0748 48.67,17.5474 C48.67,18.9046 47.57,20.0047 46.21,20.0047 C44.86,20.0047 43.76,18.9046 43.76,17.5474 C43.76,10.789 38.28,5.3102 31.52,5.3102 C24.76,5.3102 19.28,10.789 19.28,17.5474 C19.28,24.2383 24.65,29.675 31.32,29.783 L31.52,29.785 L55.44,29.785 C56.8,29.785 57.9,30.885 57.9,32.242 C57.9,33.56 56.86,34.636 55.56,34.697 L55.44,34.699 L31.52,34.699 Z" />
          <path d="M52.64,23.4772 C53.57,22.545 55.07,22.5183 56.03,23.3973 L56.11,23.4772 L63.14,30.505 C64.07,31.437 64.1,32.932 63.22,33.896 L63.14,33.98 L56.11,41.007 C55.15,41.967 53.6,41.967 52.64,41.007 C51.71,40.075 51.68,38.58 52.56,37.616 L52.64,37.532 L57.93,32.242 L52.64,26.952 C51.71,26.02 51.68,24.5252 52.56,23.5609 L52.64,23.4772 Z" />
          <path d="M3.34,34.77 C1.98,34.77 0.88,33.669 0.88,32.312 C0.88,30.994 1.92,29.918 3.22,29.858 L3.34,29.855 L13.42,29.855 C14.77,29.855 15.87,30.955 15.87,32.312 C15.87,33.631 14.83,34.706 13.53,34.767 L13.42,34.77 L3.34,34.77 Z" />
        </g>
      </g>
    </g>
  </svg>
);
